import { throwError as observableThrowError } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { ModaleErroreStore } from "../store/modale-errore.store";
import { env } from "@env/environment";
import { AttoDTO } from "../dto/atto-DTO";
import { AttoVO } from "../vo/attoVO";
import { MapperAtto } from "../mapper/mapper-atto";
import { FiltroRicercaAttoVO } from "../vo/filtro-ricerca-attoVO";
import { PaginazioneVO } from "../vo/paginazioneVO";
import { OrdinamentoVO } from "../vo/ordinamentoVO";
import { ResultListVO } from "../vo/resultList.vo";
import { MapperFiltroRicercaAtto } from "../mapper/mapper-filtro-ricerca-atto";
import { FiltroRicercaAttoDTO } from "../dto/filtro-ricerca-attoDTO";
import { ResultListDTO } from "../dto/result-listDTO";
import { MapperResultListAtto } from "../mapper/mapper-resultList-atto";
import { AttoRequestDTO } from "../dto/atto-requestDTO";
import { VisibilitaAttoVO } from "../vo/visibilita-attoVO";
import { VisibilitaAttoDTO } from "../dto/visibilita-attoDTO";
import { MapperVisibilitaAtto } from "../mapper/mapper-visibilita-atto";
import { MapperVisibilitaRequest } from "../mapper/mapper-visibilita-request";
import { MapperBaseResponse } from "../mapper/mapper-baseresponse";
import { MapperModificaVisibilitaRequest } from "../mapper/mapper-modifica-visibilita-request";
import { TipoOperazioneAttoEnum } from "../enum/tipo-operazione-atto-enum";
import { OperazioneSuAttoDTO } from "../dto/operazione-attoDTO";
import { FormCreaCorrispondenzaPartenzaVO } from "../vo/gescor/form-crea-corrispondenza-partenzaVO";
import { BaseResponseVO } from "../vo/base-responseVO";
import { BaseResponseDTO } from "../dto/base-responseDTO";
import { MapperCreaCorrispondenzaPartenza } from "../mapper/gescor/mapper-crea-corrispondenza-partenza";
import { ContoCapienzaVO } from "../vo/conto-capienzaVO";
import { ContoCapienzaDTO } from "../dto/conto-capienzaDTO";
import { MapperContoCapienza } from "../mapper/mapper-conto-capienza";

@Injectable({
  providedIn: "root",
})
export class AttoService {
  private urlAtto =
    env.DOCUMENTALE_ATTI_API_URL_BASE +
    env.API_DOCUMENTALE_ATTO;

  constructor(
    private httpClient: HttpClient,
    private modaleErroreStore: ModaleErroreStore,
    private mapperAtto: MapperAtto,
    private mapperFIltroRicercaAtto: MapperFiltroRicercaAtto,
    private mapperResultListFascicolo: MapperResultListAtto,
    private mapperVisibilitaAtto: MapperVisibilitaAtto,
    private mapperContoCapienza: MapperContoCapienza,
    private mapperVisibilitaReqeust: MapperVisibilitaRequest,
    private mapperBaseResponse: MapperBaseResponse,
    private mapperModificaVisibilitaRequest: MapperModificaVisibilitaRequest,
    private mapperCreaPartenza: MapperCreaCorrispondenzaPartenza,
    private baseResponseMapper: MapperBaseResponse
  ) { }

  salvaAttoBozza(attoBozza: AttoDTO): Observable<string> {
    console.log("[AttoServiceComponent][salvaAtto] url: ", this.urlAtto);
    console.log(
      "[AttoServiceComponent][salvaAtto] creaFascicoloRequestDTO:",
      attoBozza
    );

    return this.httpClient
      .post(this.urlAtto, attoBozza, { observe: "response" })
      .pipe(
        map((response) => response.headers.get("Location")),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  eliminaAttoBozza(id: string): Observable<void | object> {
    // esegue la convesione vo -> dto

    console.log("[AttoServiceComponent][eliminaAttoBozza] url: ", this.urlAtto);

    return this.httpClient.delete(this.urlAtto + id).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  modificaAttoBozza(attoBozza: AttoRequestDTO): Observable<void | object> {
    // esegue la convesione vo -> dto

    console.log(
      "[AttoServiceComponent][modificaAttoBozza] url: ",
      this.urlAtto
    );
    console.log(
      "[AttoServiceComponent][modificaAttoBozza] creaFascicoloRequestDTO:",
      attoBozza
    );

    return this.httpClient.put(this.urlAtto + attoBozza.id, attoBozza).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  avanzaAtto(
    tipoOperazione: TipoOperazioneAttoEnum,
    idAtto: string,
    data: OperazioneSuAttoDTO
  ): Observable<void | object> {
    // esegue la convesione vo -> dto

    console.log("[AttoServiceComponent][avanzaAtto] url: ", this.urlAtto);
    console.log(
      "[AttoServiceComponent][avanzaAtto] tipoOperazione:",
      tipoOperazione
    );

    return this.httpClient
      .put(
        this.urlAtto +
        idAtto +
        "/avanza?operazione=" +
        tipoOperazione.toString(),
        data
      )
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  recuperaAttoById(idAtto: string): Observable<AttoVO> {
    console.log("[AttoServiceComponent][recuperaAttoById] url: ", this.urlAtto);

    return this.httpClient.get(this.urlAtto + idAtto).pipe(
      map((response: AttoDTO) => this.mapperAtto.convertDtoToVo(response)),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  public creaPartenzaBozza(
    creaPartenza: FormCreaCorrispondenzaPartenzaVO,
    idAtto: string
  ): Observable<string> {
    const urlCreaPartenza = this.urlAtto + idAtto + "/crea-bozza-partenza";
    return this.httpClient
      .post<string>(
        urlCreaPartenza,
        this.mapperCreaPartenza.convertVoToDto(creaPartenza),
        { observe: "response" }
      )
      .pipe(
        map((response) => response.headers.get("Location")),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  ricercaAvanzata(
    filtro: FiltroRicercaAttoVO,
    escludiVisibilita: boolean,
    paginazione: PaginazioneVO,
    ordinamento: OrdinamentoVO
  ): Observable<ResultListVO<AttoVO>> {
    let url = this.urlAtto + env.URL_RICERCA_AVANZATA_ATTO;
    console.log("[AttoServiceComponent][ricercaAvanzata] url", url);
    console.log("[FascicoloServiceComponenrit][cercaFascicoli] filtro", filtro);

    const params = new HttpParams()
      .set("pageElement", paginazione.size.toString())
      .set("pageNumber", paginazione.pageNumber.toString())
      .set("orderBy", ordinamento.elemento.toString())
      .set("direction", ordinamento.direzione.toString());
    console.log("[AttoServiceComponent][ricercaAvanzata] params", params);
    const filtroDTO: FiltroRicercaAttoDTO = this.mapperFIltroRicercaAtto.convertVoToDto(
      filtro
    );
    if (escludiVisibilita) {
      url = url + "?escludiVisibilita=true";
    }
    return this.httpClient.post(url, filtroDTO, { params: params }).pipe(
      map(
        (resultList: ResultListDTO<AttoDTO>) =>
          this.mapperResultListFascicolo.convertDtoToVo(resultList) // creare result list e filtro
      ),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  getElencoVisibilitaById(id: string): Observable<VisibilitaAttoVO[]> {
    console.log("[AttoServiceComponent][getElencoVisibilitaById]");
    return this.httpClient
      .get<VisibilitaAttoDTO[]>(this.urlAtto + id + "/visibilita")
      .pipe(
        map((response) =>
          this.mapperVisibilitaAtto.convertListDtoToVo(response)
        ),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  getListaContiCapienza(
    esercizio: string,
    periodo: string,
    area: string,
    conto: string
  ): Observable<ContoCapienzaVO> {
    console.log("[AttoServiceComponent][getListaContiCapienza]");
    let url =
      this.urlAtto + "conti?esercizio=" + esercizio + "&periodo=" + periodo;
    if (area !== null) {
      url = url + "&area=" + area;
    }
    if (conto !== null) {
      url = url + "&conto=" + conto;
    }

    return this.httpClient.get<ContoCapienzaDTO>(url).pipe(
      map((response) => this.mapperContoCapienza.convertDtoToVo(response)),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  /** PUT: save richiesta to the server */
  aggiungiVisibilitaAtto(
    listaVisibilitaAtto: VisibilitaAttoDTO[],
    idAtto: string
  ): Observable<Object> {
    // esegue la convesione vo -> dto

    console.log(
      "[RichiestaService]aggiungiVisibilitaRichiesta: request: ",
      listaVisibilitaAtto,
      ", idRichiesta: ",
      idAtto
    );
    let attoUrl = this.urlAtto + idAtto + "/aggiungi-visibilita";

    return this.httpClient.put(attoUrl, listaVisibilitaAtto).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }
}
